import React, { useState, useEffect } from "react";
import "./style.css";
import { useTranslation } from "react-i18next";

const FloatingBar = ({ showAlways }) => {
  const { t } = useTranslation("footer");
  const floatingBar = t("floatingBarData", { returnObjects: true });

  const [showBar, setShowBar] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 150) {
        // adjust scroll value as needed
        setShowBar(true);
      } else {
        setShowBar(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (!showBar && !showAlways) return null; // don't render until user scrolls

  return (
    <>
      <div className="floating-bar-container">
        <div className="container">
          <div className={`floating-bar ${showAlways ? "show-always" : ""} ${showBar ? "fade-in" : ""}`}>
            <div className="d-flex align-items-center">
              <div className="d-flex align-items-center">
                <a
                  href="https://clutch.co/profile/bitsclan-it-solutions?utm_source=widget&utm_medium=2&utm_campaign=widget&utm_content=logo&utm_term=bitsclan.com#highlights"
                  target="_blank"
                >
                  <img
                    src="/images/clutch-footer.svg"
                    className="floating-bar-clutch-iocn me-3"
                    width={80}
                    alt="Clutch"
                  />
                </a>
                <img
                  src="/images/chris-avatar.svg"
                  alt="Chris from Bitsclan"
                  className="floating-bar-avatar rounded-circle"
                />
              </div>
              <div className="floating-bar-text">
                <h5 className="floating-bar-title mb-0">{floatingBar.title}</h5>
                <p className="floating-bar-subtitle mb-0 d-none d-md-block">
                  {floatingBar?.description}
                </p>
              </div>
            </div>
            <a
              href="https://calendly.com/bitsclan-it/30min?"
              target="_blank"
              className="floating-bar-btn btn"
            >
              {floatingBar?.buttonText}
            </a>
          </div>
        </div>
      </div>
    </>
  );
};

export default FloatingBar;
